import { ApiPage } from '@tytapp/api';

export const DEFAULT_HOME_CONTENT: ApiPage = {
    "id": "c859141ca21ec9eae",
    "title": "Home",
    "url": "/home",
    "description": "Home Page Test",
    "blocks": [
        {
            "id": "7d1bfb7b-8744-49e5-9ed7-f0cc737f2f52",
            "type": "carousel",
            "slides": [
                {
                    "intended_audience": [
                        "visitor",
                        "registered",
                        "member",
                        "expired member"
                    ]
                }
            ],
            "selectionMode": "homePage"
        },
        {
            "id": "ab335a6e-5ccb-4644-af14-447997090154",
            "type": "onboarding-c2a",
            "secondary": false
        },
        {
            "id": "915d308e-448e-44ce-8971-af4eb7f90f4b",
            "type": "content-view",
            "blocks": [
                {
                    "id": "81bdd5d8-caff-43f7-9139-9c545d58e9e7",
                    "type": "featured-members",
                    "secondary": false
                },
                {
                    "id": "cc58f24d-68cf-4264-a527-1757c0600e73",
                    "type": "live-schedule",
                    "secondary": true
                },
                {
                    "id": "65b13936-aa93-4151-9316-d8ea755b064b",
                    "type": "continue-watching",
                    "secondary": false
                },
                {
                    "id": "2596a163-0c71-47b1-a93e-ca1d3b5bf7df",
                    "type": "paid-support-c2a",
                    "secondary": false
                },
                {
                    "id": "bb3b35f4-7bd2-4119-998f-5ab995fc85ac",
                    "type": "must-see-shows",
                    "secondary": false
                },
                {
                    "id": "d4367a45-9629-4d51-b17e-40db6a98bbe9",
                    "type": "newsletter-signup",
                    "secondary": true
                },
                {
                    "id": "ec27281e-ea8b-4949-8275-69eecc0b5d42",
                    "type": "poll",
                    "secondary": true,
                    "selectionMode": "featured"
                },
                {
                    "id": "f1c091af-593e-437c-ae8b-da7c69d7778b",
                    "type": "petition",
                    "secondary": false,
                    "selectionMode": "featured"
                },
                {
                    "id": "f2ebe2f8-dbd9-48b0-9cc9-f6a6a140e71c",
                    "type": "hope-c2a",
                    "message": "We can only create hope with your support.",
                    "actionUrl": "/join/membership",
                    "secondary": false,
                    "actionText": "Support this Community",
                    "backgroundImageUrl": "/assets/operation-hope/support-c2a-bg.png"
                },
                {
                    "id": "16741cf2-8993-46fc-be13-0455e26d2ad3",
                    "type": "announcements",
                    "secondary": true
                },
                {
                    "id": "b2e9fa22-9fe3-4d76-aaba-c25e2dec89a0",
                    "icon": {
                        "text": "notifications_active",
                        "type": "material"
                    },
                    "more": {
                        "url": "https://discuss.tyt.com/",
                        "icon": {
                            "text": "open_in_new",
                            "type": "material"
                        },
                        "label": "More"
                    },
                    "sort": "latest",
                    "type": "forum-posts",
                    "title": "Operation Hope",
                    "category": "operation_hope",
                    "secondary": false
                },
                {
                    "id": "df170ff4-e1de-4c51-9798-0ad71038102d",
                    "icon": {
                        "text": "notifications_active",
                        "type": "material"
                    },
                    "more": {
                        "url": "https://discuss.tyt.com/",
                        "icon": {
                            "text": "open_in_new",
                            "type": "material"
                        },
                        "label": "More"
                    },
                    "sort": "top",
                    "type": "forum-posts",
                    "title": "Operation Hope",
                    "category": "operation_hope",
                    "secondary": false
                },
                {
                    "id": "3f89b17d-c28c-4d85-92fe-a6a4fc5f95b2",
                    "type": "how-to-watch",
                    "secondary": true
                },
                {
                    "id": "43b89365-9298-4dae-9b83-1d0614976b0e",
                    "type": "followed-topic",
                    "count": 0,
                    "start": 7,
                    "secondary": true
                },
                {
                    "id": "0d1e6256-86a7-4a5c-adfd-ae0fa27a26bc",
                    "type": "followed-topic",
                    "count": 0,
                    "start": 1,
                    "secondary": false
                }
            ],
            "hidden": false,
            "secondary": false
        }
    ],
    "is_published": false,
    "is_archived": false
};